import { useEffect, useState } from "react";

const Score = (props) => {
  let scoreClass = 'score',
    percentClass = 'percent';

  const [score, setScore] = useState(0);

  if (props.score > 65) {
    scoreClass = 'score score--active';
    percentClass = 'percent percent--complete';
  }

  if (props.score <= 65) {
    scoreClass = 'score score--active';
    percentClass = 'percent percent--attention';
  }

  useEffect(() => {
    if( props.score > 0 ) {
      setTimeout(function() {
        setScore(props.score);
      }, 100)
    }
  }, [props.score])

return (
  <div className={scoreClass}>
    <div className={percentClass}>
      <svg>
        <circle cx="35" cy="35" r="35"></circle>
        <circle
          cx="35"
          cy="35"
          r="35"
          style={{
            strokeDashoffset: `calc(220 - (220 * ${score}) / 100)`,
          }}
        ></circle>
      </svg>
      <div className="number">
        <h2>{props.score}%</h2>
      </div>
    </div>
  </div>
);
};

export default Score;
